import {$window, $body, Breakpoints} from '../Constants';
import Nav from './Nav';

/**
 * NavMain
 */
const NavMain = (() => {
  // Constants
  const DATA_KEY = 'ig.nav-main';
  const EVENT_KEY = `.${DATA_KEY}`;
  const MOBILE_BREAKPOINT = Breakpoints.LARGE;

  /**
   * Selector
   */
  const Selector = {
    NAV_MAIN: '.menu-main',
    LABEL: '.label-menu',
    CHECKBOX: '.input-menu',
    TOGGLE_MENU_MAIN: '.toggle-menu-main'
  };

  /**
   * Event
   */
  const Event = {
    LABEL_CLICK: `click.label${EVENT_KEY}`,
    RESIZE: `resize${EVENT_KEY}`
  };

  /**
   * NavMain
   *
   * @class
   * @augments Nav
   */
  class NavMain extends Nav {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$labels = this._$element.find(Selector.LABEL);
      this._setLabelsHeight();
      super.onReady();
	  // Unfold mobile menu to current "position"
	  this._$element.find('.act > input').prop('checked', true);
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      super._bindHandlers();

      this._$labels.on(Event.LABEL_CLICK, (e) => {
        e.preventDefault();

        let $checkbox = $(e.currentTarget).prev(Selector.CHECKBOX);

        if ($checkbox.prop('checked') === true) {
          $checkbox.prop('checked', false);
        } else {
          $checkbox.prop('checked', true);
        }

        this._setLabelsHeight();
      });

      $window.on(Event.RESIZE, () => {
        this._setLabelsHeight();
      });
    }

    /**
     * Sets the height of the labels according to it's link height
     *
     * @return void
     */
    _setLabelsHeight() {
      if ($window.width() <= MOBILE_BREAKPOINT) {
        this._$labels.not(Selector.TOGGLE_MENU_MAIN).each((i, el) => {
          let $label = $(el);
          let $a = $label.parent('li').find('> a');

          $label.css('height', $a.outerHeight());
        });
      }
    }
  }

  return NavMain._getElement($body.find(Selector.NAV_MAIN), NavMain);
})();

export default NavMain;
